// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"dd61a48c","562":"7d4c5c81","742":"3ed5df09","786":"f6b64d30","787":"ac3771e9","916":"9478c14a","952":"4fe4b2fe"}[chunkId] + ".chunk.js";
};